import { useEffect, PropsWithChildren, useMemo } from 'react';

import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';

import api from '@@/api';
import SpinnerView from '@@/auto/components/SpinnerView';
import { store } from '@@/auto/store';
import { identifyUserToAllServices } from '@@/auto/utils/analytics';
import { getOktaIssuer } from '@@/common/utils/getOktaIssuer';

function SyncOktaAuthStateToAppState() {
  const { oktaAccessToken, oktaIdToken, user } = store.getState();

  useEffect(() => {
    if (oktaAccessToken) {
      api.setAuthHeader(oktaAccessToken.accessToken);
    }

    if (oktaIdToken) {
      identifyUserToAllServices(oktaIdToken.claims, user || undefined);
    }
  }, [oktaIdToken, oktaAccessToken, user]);

  return null;
}

export function Authn({ children }: PropsWithChildren<{}>) {
  const history = useHistory();
  const oktaIssuer = getOktaIssuer();

  const oktaAuth = useMemo(() => {
    return new OktaAuth({
      issuer: oktaIssuer,
      clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
      redirectUri: `${window.location.origin}${process.env.REACT_APP_OKTA_REDIRECT_URI}`,
      responseType: ['id_token', 'token'],
      pkce: false,
      cookies: {
        secure: process.env.REACT_APP_ENV !== 'development',
      },
    });
  }, [oktaIssuer]);

  if (!oktaIssuer) {
    return <SpinnerView data-testid="App_spinner" />;
  }

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
    window.console.log('originalUri: ', originalUri);
    window.console.log('baseUrl: ', window.location.origin);

    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <SyncOktaAuthStateToAppState />
      {children}
    </Security>
  );
}
